module.exports = __webpack_public_path__ + "img/coche.5808e40e.svg";